"use client";
import Container from "@/components/Container";
import TitleWithDash from "@/components/TitleWithDash";
import { PrismicRichText } from "@prismicio/react";
import React from "react";

const IntroSection = ({ slice }) => {
  const titleComponent = {
    heading2: ({ children }) => (
      <h2 className="mb-3 title-large title-font text-start sm:title-xl">
        {children}
      </h2>
    ),
    heading3: ({ children }) => (
      <h3 className="mb-3 title-large title-font text-start">{children}</h3>
    ),
    heading4: ({ children }) => (
      <h4 className="mb-3 title-large title-font text-start">{children}</h4>
    ),
  };
  const subTitleComponent = {
    heading3: ({ children }) => (
      <h3 className="text-medium  body text-[#B78562]  ">{children}</h3>
    ),
    heading4: ({ children }) => (
      <h4 className="text-medium  body text-[#B78562]  ">{children}</h4>
    ),
    heading5: ({ children }) => (
      <h5 className="text-medium  body text-[#B78562]  ">{children}</h5>
    ),
    paragraph: ({ children }) => (
      <p className="text-medium  body text-[#B78562]  ">{children}</p>
    ),
    strong: ({ children }) => (
      <strong className="font-semibold">{children}</strong>
    ),
    hyperlink: ({ children, node }) => (
      <PrismicNextLink
        field={node.data}
        className="font-normal decoration-1 underline-offset-2 text-medium text-start body"
      >
        {children}
      </PrismicNextLink>
    ),
  };

  const bodyComponent = {
    heading3: ({ children }) => (
      <h3 className="text-base text-start body md:w-fit">{children}</h3>
    ),
    heading4: ({ children }) => (
      <h4 className="text-base text-start body md:w-fit">{children}</h4>
    ),
    heading5: ({ children }) => (
      <h5 className="text-base text-start body md:w-fit">{children}</h5>
    ),
    paragraph: ({ children }) => (
      <p className="text-base text-start body md:w-fit">{children}</p>
    ),
  };

  return (
    <Container slice={slice}>
      <div className="flex flex-col items-center gap-y-[22px]  md:flex-row md:gap-x-[34px] md:items-start lg:gap-x-[54px] ">
        <div className="w-full md:max-w-[280px]  lg:max-w-[470px]">
          <TitleWithDash
            title={
              <div className="lg:pr-[34px] lg:border-r-[0.5px]">
                <PrismicRichText
                  field={slice?.primary?.intro_title}
                  components={titleComponent}
                />
                <PrismicRichText
                  field={slice?.primary?.intro_subtitle}
                  components={subTitleComponent}
                />
              </div>
            }
            dashColor={"#c4c4c8"}
            className="flex-grow-0 flex-shrink-0 lg:w-64 lg:h-auto"
          />
        </div>
        <div className="flex flex-col  md:max-w-[374px] lg:max-w-[666px] lg:flex-row lg:gap-[30px] gap-[15px] ">
          <PrismicRichText
            field={slice?.primary?.intro_description_1}
            components={bodyComponent}
          />
          <PrismicRichText
            field={slice?.primary?.intro_description_2}
            components={bodyComponent}
          />
        </div>
      </div>
    </Container>
  );
};

export default IntroSection;
